import {Component, Input, OnInit} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import {BATCH_COLORS} from "../../BATCH_COLORS";

@Component({
    selector: 'app-app-for-batch-pie-chart',
    templateUrl: './app-for-batch-pie-chart.component.html',
    styleUrls: ['./app-for-batch-pie-chart.component.scss']
})
export class AppForBatchPieChartComponent implements OnInit {
    private _batchData: any;
    get batchData() {
        return this._batchData;
    }

    @Input() set batchData(val: any) {
        this._batchData = val;
        if (val) {
            this.applicationBatchDashboard = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'donut',
                    sparkline: {
                        enabled: true
                    }
                },
                // legend : {
                //     show : true,
                //     position : 'right'
                // },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '13px',
                        // fontWeight: 'bold',
                    },
                    dropShadow: {enabled: false}
                },
                colors: BATCH_COLORS,
                labels: val.labels,
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        // donut: {
                        //     size: '100%'
                        // },
                        // dataLabels:{
                        //     offset: -20,  style: {

                        // }
                    }
                },
                series: val.series.map(p => p.percentageValue),
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    custom: ({
                                 seriesIndex,
                                 w
                             }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
                }
            };
        }
    }

    applicationBatchDashboard: ApexOptions;

    constructor() {
    }

    ngOnInit(): void {
    }

}
